import { GetDefaultPlansYear, GetNextPlansYear } from '@coverright/utils';
import { useEffect } from 'react';
import {
  PdpField,
  PdpSort
} from '@coverright/data-access/types/medicare';
import {
  PdpPlansTotalDocument, PdpQuoteQuery,
  usePdpFiltersQuery,
  usePdpPlanListSuspenseQuery, usePdpPlansSortQuery, usePdpPlanYearQuery
} from '..';
import { mainBackendApolloCache } from '@coverright/data-access/apollo-clients';

export function usePdpPlans(quote: PdpQuoteQuery['pdpQuote'], pageSize: number) {
  const {data: planYearData} = usePdpPlanYearQuery();
  const planYear = planYearData?.pdpPlanYear;

  const {data: companiesData} = usePdpFiltersQuery();
  const companies = companiesData?.pdpFilters?.companies || [];
  const rating = companiesData?.pdpFilters?.rating || [];

  const {data: sortData} = usePdpPlansSortQuery();
  const sortBy = sortData?.pdpPlansSort || PdpField.MonthlyCost;

  const { data, fetchMore } = usePdpPlanListSuspenseQuery({
    skip: !quote,
    variables: {
      filter: {
        zip: quote!.zip!,
        countyName: quote!.countyName!,
        planYear: planYear || GetDefaultPlansYear(),
        companies,
        rating,
      },
      // Next year's plans run a full calendar year; the current year's are priced for whatever is
      // left of it. The old expression compared two constants that can never be equal, so this was
      // always false - which is still the right answer for the current year, and now also the
      // right one for next year.
      fullYear: (planYear || GetDefaultPlansYear()) === GetNextPlansYear(),
      page: {
        size: pageSize,
        page: 0,
      },
      clientId: quote?.clientId,
      sort: [
        { pdpField: sortBy || PdpField.MonthlyCost, direction: PdpSort.Asc },
      ],
    },
  });

  useEffect(() => {
    mainBackendApolloCache.writeQuery({
      query: PdpPlansTotalDocument,
      data: {
        pdpPlansTotal: data.PdpPlans.totalElements
      }
    })
  }, [data.PdpPlans]);

  return { plans: data.PdpPlans, fetchMore };
}
